import { createStructuredSelector } from 'reselect';
import { imagesForAssetsPanel } from 'containers/Documents/selectors';
import { documentIdsAreBeingUploaded } from 'containers/Project/selectors';

export const mobileViewImageSelector = createStructuredSelector({
  imagesForAssetsPanel,
  documentIdsAreBeingUploaded,
});
